var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpirometr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.771 4.44954C13.8282 5.42373 12.7723 6.50478 12.6969 6.55506L10.8428 5.1409C10.8428 5.1409 12.6655 3.22394 13.2625 2.6897C13.8596 2.15546 15.7137 3.47534 14.771 4.44954Z",
    fill: "url(#paint0_linear_103_23184)",
    stroke: "#26282B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.294 2.75537C12.8855 3.32103 14.1739 4.54663 14.9282 4.23238",
    stroke: "#707782",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6401 16.3311C13.6401 18.091 9.71191 19.6308 9.71191 17.6824V10.8317C9.71191 9.95175 10.2776 9.13465 10.2462 8.63185C10.2147 8.12905 9.71191 8.31759 9.71191 7.53195V6.58918C9.71191 4.51509 12.1631 4.32653 12.8231 4.7665C13.483 5.20646 13.6401 5.52073 13.6401 6.14923C13.6401 6.77773 13.2002 6.99773 13.2002 7.65765C13.2002 8.31758 13.6401 8.09763 13.6401 8.91469V16.3311Z",
    fill: "url(#paint1_linear_103_23184)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9287 18.5896C10.0244 18.7166 7.7002 18.8905 7.7002 17.3211V10.4704C7.7002 9.59045 8.26586 8.77335 8.23443 8.27056C8.20301 7.76776 7.7002 7.9563 7.7002 7.17066V6.22789C7.7002 5.18674 8.67439 4.07519 10.3714 4.13805C11.2363 4.17008 12.2835 4.4001 12.5454 4.64084C12.1526 4.53105 11.7782 4.57151 11.4084 4.64084C10.6542 4.78222 9.74286 5.59939 9.74286 6.22789V7.72056C9.74286 8.17628 10.2142 8.11343 10.2142 8.66332C10.2142 9.21322 9.74286 9.9832 9.74286 10.6117C9.74286 12.6858 9.63585 16.7661 9.74286 17.9967C9.92862 18.5747 10.5346 18.6239 10.9287 18.5896C11.1471 18.5589 11.2827 18.531 11.2827 18.531C11.2827 18.531 11.1347 18.5717 10.9287 18.5896Z",
    fill: "url(#paint2_linear_103_23184)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3903 10.8978C10.5949 10.1383 13.0783 9.02818 13.1952 9.554C13.312 10.0798 13.3412 15.2505 13.1952 16.0684C13.0491 16.8864 10.6533 17.7335 10.3903 17.2661C10.1274 16.7987 10.1858 11.6573 10.3903 10.8978Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4082 16.331C11.4082 16.2682 10.7168 16.5196 10.7168 16.6138C10.7168 16.7081 10.7482 16.8967 10.8111 16.9595C10.8739 17.0224 11.4082 16.9336 11.4082 16.8652V16.331Z",
    fill: "#46B5E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5342 16.8026V16.2684C11.5342 16.2055 12.4455 15.797 12.4455 15.8598V16.3941C12.4455 16.4569 11.5342 16.8969 11.5342 16.8026Z",
    fill: "#E67033"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.571 16.3311C12.5081 16.2997 12.5395 15.8911 12.571 15.7969C12.6024 15.7026 13.0109 15.4512 13.0109 15.5455C13.0109 15.6397 12.9481 16.0483 12.8852 16.1425C12.8224 16.2368 12.6338 16.3625 12.571 16.3311Z",
    fill: "#46B5E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6543 15.4513V11.1459C10.6543 10.9574 12.8855 10.0146 12.8855 10.1089V14.4771C12.8855 14.6028 10.6543 15.577 10.6543 15.4513Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7169 16.331C10.6855 16.2681 10.6855 15.891 10.7169 15.8282C10.7484 15.7653 12.8853 14.7911 12.9167 14.854C12.9481 14.9168 12.9481 15.2625 12.9167 15.3254C12.8853 15.3882 10.7484 16.3938 10.7169 16.331Z",
    fill: "url(#paint3_linear_103_23184)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_23184",
    x1: 12.3826,
    y1: 3.44657,
    x2: 14.1739,
    y2: 5.17498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_23184",
    x1: 11.6292,
    y1: 4.26908,
    x2: 11.676,
    y2: 18.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0520833,
    stopColor: "#F2F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161655,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_23184",
    x1: 11.7597,
    y1: 3.74534,
    x2: 9.79543,
    y2: 19.0667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0415755,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275446,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322078,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437073,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543782,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945955,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898989"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_23184",
    x1: 12.9167,
    y1: 15.7025,
    x2: 10.6541,
    y2: 15.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "#FF0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpirometr);
export default __webpack_public_path__ + "static/media/spirometr.937562defcf75299df73cc7be36e7f3c.svg";
export { ForwardRef as ReactComponent };